import React, { useState } from 'react';
import { Form, Button, Container, Row, Col, Alert, Card, Modal } from 'react-bootstrap';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { auth } from './firebase';

function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const [showReset, setShowReset] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const [resetError, setResetError] = useState(null);
  const [resetLoading, setResetLoading] = useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      setLoading(false);
      onLogin();
    } catch (err) {
      setLoading(false);
      setError('Erreur de connexion : ' + err.message);
    }
  };

  const handleResetPassword = async () => {
    setResetError(null);

    if (!resetEmail) {
      setResetError('Veuillez entrer une adresse email.');
      return;
    }

    setResetLoading(true);
    try {
      await sendPasswordResetEmail(auth, resetEmail);
      setResetLoading(false);
      setShowReset(false);        // Fermer la modale
      setShowSuccessAlert(true);  // Afficher l’alerte succès
      setResetEmail('');
      setTimeout(() => setShowSuccessAlert(false), 5000); // Masquer après 5s
    } catch (error) {
      setResetLoading(false);
      setResetError('Erreur : ' + error.message);
    }
  };

  return (
    <Container style={{ minHeight: '100vh' }} className="d-flex align-items-center justify-content-center">
      <Row className="w-100 justify-content-center">
        <Col xs={12} sm={10} md={6} lg={4}>
          <Card className="p-4 shadow">
            <Card.Body>
              <h2 className="text-center mb-4">Connexion</h2>
              {showSuccessAlert && <Alert variant="success">Email de réinitialisation envoyé avec succès.</Alert>}
              {error && <Alert variant="danger">{error}</Alert>}
              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="formEmail" className="mb-3">
                  <Form.Label>Adresse email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Entrez votre email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    required
                    autoFocus
                  />
                </Form.Group>

                <Form.Group controlId="formPassword" className="mb-4">
                  <Form.Label>Mot de passe</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Mot de passe"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    required
                  />
                </Form.Group>

                <Button variant="primary" type="submit" className="w-100" disabled={loading}>
                  {loading ? 'Connexion...' : 'Se connecter'}
                </Button>
              </Form>

              <div className="mt-3 text-center">
                <Button variant="link" onClick={() => setShowReset(true)}>
                  Mot de passe oublié ?
                </Button>
              </div>

              <Modal show={showReset} onHide={() => setShowReset(false)} centered>
                <Modal.Header closeButton>
                  <Modal.Title>Réinitialisation du mot de passe</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {resetError && <Alert variant="danger">{resetError}</Alert>}
                  <Form.Group controlId="resetEmail">
                    <Form.Label>Adresse email</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Entrez votre email"
                      value={resetEmail}
                      onChange={e => setResetEmail(e.target.value)}
                      autoFocus
                    />
                  </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={() => setShowReset(false)}>
                    Annuler
                  </Button>
                  <Button variant="primary" onClick={handleResetPassword} disabled={resetLoading}>
                    {resetLoading ? 'Envoi...' : 'Envoyer'}
                  </Button>
                </Modal.Footer>
              </Modal>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default Login;
